/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 685246d273245ef509ab9a6ca4ebe1c0 */

import { ConcreteRequest } from "relay-runtime";

export type NotificationsActivateUserMutationVariables = {
    id: string;
};
export type NotificationsActivateUserMutationResponse = {
    readonly inviteAccept: {
        readonly invite: {
            readonly id: string | null;
        } | null;
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
        }> | null;
    } | null;
};
export type NotificationsActivateUserMutation = {
    readonly response: NotificationsActivateUserMutationResponse;
    readonly variables: NotificationsActivateUserMutationVariables;
};



/*
mutation NotificationsActivateUserMutation(
  $id: ID!
) {
  inviteAccept(id: $id) {
    invite {
      id
    }
    errors {
      message
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "InvitePayload",
    "kind": "LinkedField",
    "name": "inviteAccept",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Invite",
        "kind": "LinkedField",
        "name": "invite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsActivateUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsActivateUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "685246d273245ef509ab9a6ca4ebe1c0",
    "metadata": {},
    "name": "NotificationsActivateUserMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '4e6929bb70c450abd2f2c46c328eb985';
export default node;
